
import {
  DateCalendar as MuiDateCalender,
  PickersDay,
  PickersDayProps,
} from '@mui/x-date-pickers-pro';
import { IEditComponentProps } from '../../Components/Attributes/EditableAttribute/EditComponentTypes';
import { dateToStr, tryStrToDate } from '../../Utils/stringUtils';
import { isRedDay } from '../../Utils/dayNames';
import EDBox from '../EDBox/EDBox';

interface IProps extends IEditComponentProps<any> {
  onDateChange?: (newValue: string, isValidDate: boolean) => void;
}

const Holidays = (props: PickersDayProps & { highlightedDays?: number[] }) => {
  const { day, ...other } = props;
  const redDay = isRedDay(day);

  return (
    <EDBox
      data-testid={'Holidays'}
      component={'span'}
      sx={
        redDay
          ? theme => ({
              '& > :first-of-type': {
                color: theme.palette.error.main,
              },
            })
          : undefined
      }
    >
      <PickersDay data-testId={'pickersDay'} {...other} day={day} />
    </EDBox>
  );
};

export const EDDateCalender: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const dateCalender = (
    <MuiDateCalender
      slots={{
        day: Holidays,
      }}
      value={tryStrToDate(props.value ?? '') ?? null}
      onChange={date => {
        if (date != null && typeof date === 'object') {
          props.onDateChange?.(dateToStr(date), true);
        } else {
          props.onDateChange?.('', false);
        }
      }}
      displayWeekNumber
      data-testId={'edDateCalendar'}
      views={['year', 'month', 'day']}
    />
  );

  return dateCalender;
};

export default EDDateCalender;
